<template>
    <div class="sub-layout">
        <div class="sub_toptit">
            <h1>Login</h1>
        </div>
        <div class="contentBox loginBox">
            <div class="container">
                <div class="loginarea">
                    <form action="">
                        <div class="loginBox_inner">
                            <div class="loginBox_inner_input">
                                <label for="username">Email <span class="required">*</span></label>
                                <input type="text" v-model="email" @keyup.enter="login">
                                <p class="error" v-if="error"><i class="pi pi-info-circle"></i>Email is required.</p>
                            </div>
                            <div class="loginBox_inner_input">
                                <label for="password">Password <span class="required">*</span></label>
                                <input type="password" v-model="password" @keyup.enter="login">
                                <p class="error" v-if="error"><i class="pi pi-info-circle"></i>The password field is empty.</p>
                            </div>
                            <div class="loginBox_inner_btn">
                                <button type="button" @click="login">Login</button>
                            </div>
                            <div class="loginBox_inner_find">
                                <div class="loginBox_inner_find_chk">
                                    <input type="checkbox" v-model="rememberme" id="remember">
                                    <label for="remember">Remember me</label>
                                </div>
                                <div class="loginBox_inner_find_link">
                                    <router-link to="/forgotpassword" class="loglinktxt">Forgot your password?</router-link>
                                    <span>Do not have account yet? <router-link to="/signup" class="loglinktxt"> Sign up </router-link>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </form>

                    <div class="sns_login">
                        <ul>
                            <li>
                                <button type="button" @click="signInWithFacebook" class="facebook">
                                    <img src="@/assets/img/facebook-brand-white.png" alt="Login with facebook">
                                    <span class="txt">Login with Facebook</span>
                                </button>
                            </li>
                            <li>
                                <button type="button" @click="signInWithGoogle" class="google">
                                    <img src="@/assets/img/google-brand.png" alt="Login with google">
                                    <span class="txt">Login with Google</span>
                                </button>
                            </li>
                            <li>
                                <button type="button" @click="signInWithLinkedIn" class="linkedin">
                                     <img src="@/assets/img/linkedin.png" alt="Login with Linked In">
                                    <span class="txt">Login with Linked In</span>
                                </button>
                            </li>
                        </ul>
                        <p class="socialtxt">SNS accounts available for sign-up</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { supabase } from '@/API/supabase';

export default {
    name: 'login',
    data() {
        return {
            error: false, // error message
            email: '',
            password: '',
            rememberme: false,
        };
    },
    mounted() {
        // 저장된 아이디 불러오기
        const getSavedId = localStorage.getItem('savedKoreaDermaWebId');
        if (getSavedId) {
            this.email = getSavedId;
            this.rememberme = true;
        }
    },
    methods: {
        
        // 일반 이메일 로그인
        async login() {
            var userData = this.$store.getters['user'];
            if(userData.loggedIn){
                alert('Please log out first.');
                this.$router.push('/');
            }

            if (this.email === '' || this.password === '') {
                this.error = true;
                return;
            }

            var source = await this.getUserSource();

            if(source){
                if(source != "Default form"){
                    alert("Please login with " + source);
                    return;
                }
            }else{
                return false;
            }

            var params = {
                email: this.email,
                password: this.password,
            };

            this.$store.dispatch('UserAccountStore/login', params)
            .then((res) => {
                // console.log(res);
                if (res.success) {
                    var userInfo = {
                        accessToken: res.accesstoken,
                        refreshToken: res.refreshtoken,
                        email: this.email,
                        useruid: res.resultdata.useruid,
                    };

                    // console.log("userInfo: ",userInfo);

                    // 이메일 저장 체크시
                    if (this.rememberme) {
                        localStorage.setItem('savedKoreaDermaWebId', this.email);
                    } else {
                        localStorage.removeItem('savedKoreaDermaWebId');
                    }

                    this.getProfile(userInfo);
                } else {
                    alert(res.message);
                }
                return res;
            })
            .catch(({ message }) => alert(message));
        },

        // 사용자 소스 가져오기
        async getUserSource(){
            const { data, error } = await supabase
            .from('UserInfo')
            .select('source')
            .eq('email', this.email)
            .single();

            // console.log(data);

            if (error) {
                console.error('사용자 소스 가져오기 에러:', error.message);
                alert("User not found.");
                return false;
            } else {
                if(data){
                    return data.source;
                }else{
                    alert("User not found.");
                    return false;
                }
            }
        },

        // 사용자 정보 가져오기
        async getProfile(userInfo) {
            const { data, error } = await supabase
                .from('UserInfo')
                .select('*')
                .eq('useruid', userInfo.useruid);

            if (error) {
                console.error('프로필 가져오기 에러:', error.message);
            } else {
                if (data.length > 0) {
                    var userData = data[0];
                    userInfo.profileComplete = userData.lastname ? true : false;
                    
                    this.$store.commit('setLoggedIn', true);
                    this.$store.commit('setUser', userInfo);
                    
                    this.emitter.emit('watchLoginChange');

                    this.$router.push('/');
                }
            }
        },

        // 페이스북 로그인
        async signInWithFacebook() {
            const { data, error } = await supabase.auth.signInWithOAuth({
                provider: 'facebook',
            });

            console.log(data);

            if (error) {
                console.error('페이스북 로그인 에러:', error.message);
            } else {
                console.log('페이스북 로그인 성공:', data);
            }
        },

        // 구글 로그인
        async signInWithGoogle() {
            const { data, error } = await supabase.auth.signInWithOAuth({
                provider: 'google',
            });

            console.log(data);

            if (error) {
                console.error('구글 로그인 에러:', error.message);
            } else {
                console.log('구글 로그인 성공:', data);
            }
        },

        // 링크드인 로그인
        async signInWithLinkedIn() {
            const { data, error } = await supabase.auth.signInWithOAuth({
                provider: 'linkedin_oidc',
            });

            console.log(data);

            if (error) {
                console.error('링크드인 로그인 에러:', error.message);
            } else {
                console.log('링크드인 로그인 성공:', data);
            }
        },

    },
};
</script>

